export default __webpack_public_path__ + "static/media/RotaryPumpsImg.55448cbe.jpg";